/* card swipe v4 2026-10-09 — arrows + dots for .card-swipe (no libraries).
   Perf: only the first photo is in the HTML as a real image; photos 2..6 carry data-srcset and load on demand:
   - they load when the shopper starts interacting with that card (touch, hover, focus, arrow, scroll).
   All loading is paused while a grid pinch/settle is running (window.__intiGesture) and resumed afterwards. */
(function () {
  if (customElements.get('card-swipe')) return;
  var root = document.documentElement, queue = new Set();
  function busy() { return !!window.__intiGesture; }
  function loadImg(img) {
    if (!img || !img.dataset.srcset) return;
    img.loading = 'eager'; img.srcset = img.dataset.srcset; img.src = img.dataset.src;
    img.removeAttribute('data-srcset'); img.classList.remove('card-swipe__deferred');
  }
  function loadNext(el) { if (busy()) { queue.add([el, 1]); return; } loadImg(el.querySelector('img[data-srcset]')); }
  function loadAll(el) { if (busy()) { queue.add([el, 0]); return; } el.querySelectorAll('img[data-srcset]').forEach(loadImg); }
  document.addEventListener('inti:gesture-end', function () {
    var q = Array.from(queue); queue.clear();
    q.forEach(function (p) { if (p[0].isConnected) (p[1] ? loadNext : loadAll)(p[0]); });
  });

  customElements.define('card-swipe', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      var self = this;
      this.track = this.querySelector('.card-swipe__track');
      this.dots = this.querySelectorAll('.card-swipe__dot');
      this.prev = this.querySelector('.card-swipe__arrow--prev');
      this.next = this.querySelector('.card-swipe__arrow--next');
      if (!this.track) return;
      var wake = function () { loadAll(self); };
      ['touchstart', 'pointerenter', 'focusin'].forEach(function (t) { self.addEventListener(t, wake, { passive: true, once: true }); });
      var go = function (d) { return function (e) { e.preventDefault(); e.stopPropagation(); loadAll(self); self.track.scrollBy({ left: d * self.track.clientWidth }); }; };
      this.prev && this.prev.addEventListener('click', go(-1));
      this.next && this.next.addEventListener('click', go(1));
      var raf = 0;
      this.track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; loadAll(self); self.update(); });
      }, { passive: true });
    }
    update() {
      if (!this.track) return;
      var w = this.track.clientWidth || 1;
      var i = Math.round(this.track.scrollLeft / w), n = this.dots.length;
      this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (this.prev) this.prev.hidden = i <= 0;
      if (this.next) this.next.hidden = i >= n - 1;
    }
  });
})();
